import React, { createRef, useContext, useState } from 'react'

import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import Modal from '@material-ui/core/Modal'
import { makeStyles } from '@material-ui/core/styles'

import PropTypes from 'prop-types'
import Context from '../../context'
import { createEventProducer } from '../../services/ClubeApi'
import ProgressBar from '../ProgressBar'

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}))

function CreateProducerModal({ updateProducerList }) {
  const classes = useStyles()
  const exitButton = createRef()
  const { formObject, setFormObject, setOpenToast, openProducerModal, setOpenProducerModal } =
    useContext(Context)

  const [producerName, setProducerName] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSaveButton = () => {
    setIsLoading(true)
    createEventProducer(producerName).then(r => {
      if (r) {
        updateProducerList()
        setFormObject({ ...formObject, producer: r.id })
        setOpenToast({
          open: true,
          message: `Criado o Produtor ${producerName} com sucesso`,
          type: 'success'
        })
        setProducerName('')
        setOpenProducerModal(false)
      } else {
        setOpenToast({
          open: true,
          message: `Ocorreu algum erro ao criar a Produtora, tente novamente.`,
          type: 'error'
        })
      }
      setIsLoading(false)
    })
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={openProducerModal}
      onClose={() => {
        setOpenProducerModal(false)
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Fade in={openProducerModal}>
        <div className={classes.paper}>
          <div className="modal-content">
            {!isLoading ? (
              <>
                <div className="modal-header">
                  <h5 className="modal-title">Adicionar Produtora</h5>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="form-group col-md-12">
                      <label htmlFor="producerName">Nome da Produtora</label>
                    </div>
                    <div className="form-group col-md-12">
                      <input
                        id="eventName"
                        type="text"
                        className="form-control"
                        placeholder="Nome da Produtora"
                        value={producerName}
                        onChange={e => {
                          setProducerName(e.target.value)
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    ref={exitButton}
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                    onClick={() => {
                      setProducerName('')
                      setOpenProducerModal(false)
                    }}
                  >
                    Cancelar
                  </button>
                  <button
                    disabled={producerName.length < 1}
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSaveButton}
                  >
                    Salvar
                  </button>
                </div>
              </>
            ) : (
              <ProgressBar height="20px" marginBottom="10px" marginTop="10px" width="100%" />
            )}
          </div>
        </div>
      </Fade>
    </Modal>
  )
}

CreateProducerModal.propTypes = {
  updateProducerList: PropTypes.func.isRequired
}

export default CreateProducerModal
